import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SeFeApiService } from 'se-fe-api'

@Injectable({
  providedIn: 'root'
})
export class ResendVerificationService {

  constructor(
    private api: SeFeApiService
  ) { }

  public resend(uuid: string, userReturnTo?: string): Observable<any> {
    const url = `users/resend_confirmation_email/${uuid}`
    const body = userReturnTo ? { user_return_to: userReturnTo } : {}

    return this.api.post(url, body)
  }
}
